import { getTimeZoneByGeoLocation } from 'async-timing';
import { getFirstOccurrenceEndDate } from 'lane-shared/domains/visitorManagement/helpers/getFirstOccurrenceEndDate';
import { ScheduleTypeEnum } from 'constants-visitor-management';
import { ContentType } from 'lane-shared/types/content/Content';
import { DateTime } from 'luxon';

export const validateVisitorEndTime = (
  content: ContentType,
  interaction: any,
  isDateRangeEndTimeValidationFixEnabled?: boolean
) => {
  const schedule = (interaction?.features as any)?.VisitorManagement?.schedule;

  if (schedule?.AllDay) {
    return true;
  }

  const endDate = schedule?.endDate;

  if (!endDate) return false;

  const timeZone = getTimeZoneByGeoLocation({
    latitude: content?.geo[1],
    longitude: content?.geo[0],
  });

  let endDateToValidate: Date;

  if (
    isDateRangeEndTimeValidationFixEnabled &&
    schedule?.type === ScheduleTypeEnum.DateRange &&
    schedule?.startDate
  ) {
    endDateToValidate = getFirstOccurrenceEndDate(
      schedule.startDate,
      endDate,
      timeZone
    );
  } else {
    endDateToValidate = new Date(endDate);
  }

  const currentDateTime = DateTime.local().setZone(timeZone);
  const parsedEndDateTime = DateTime.fromJSDate(endDateToValidate, {
    zone: timeZone,
  });

  return currentDateTime.toMillis() <= parsedEndDateTime.toMillis();
};
